import { Link } from "@/i18n/navigation";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl space-y-4 px-6 py-24 text-center">
      <h1 className="font-display text-4xl font-bold">404</h1>
      <p className="text-txt-tertiary">This route isn&apos;t in the app SPA.</p>
      <Link href="/" className="text-accent-500 hover:underline">
        Back to start
      </Link>
    </div>
  );
}
